/**
 * The Store for the App
 */

import { writable } from 'svelte/store';

export const i18n = writable();

export const store = writable();

export function storeInit(config) {
    i18n.set(config.i18n);

    const data = { ...config };

    delete data.i18n;

    store.set(data);
}
